import Link from '@/compat/link'
import { Button } from '@/components/nexus/primitives/button'

export default function ReferrerError({
  error: _err,
  reset,
}: {
  error: Error & { digest?: string }
  reset: () => void
}) {
  return (
    <div
      data-el="referrer-error"
      className="flex min-h-[50vh] items-center justify-center px-4"
    >
      <div className="space-y-4 text-center">
        <h2 className="font-semibold text-text-primary text-xl">
          Something went wrong
        </h2>
        <p className="text-text-muted">
          We couldn't load your referrals. Please try again.
        </p>
        <div className="flex justify-center gap-3">
          <Button onClick={reset}>Try again</Button>
          <Link
            href="/app"
            className="rounded-md border border-border-default px-4 py-2 text-text-primary hover:bg-surface-muted"
          >
            Go to Stopal
          </Link>
        </div>
      </div>
    </div>
  )
}
